<div class="header">
  <h2 *ngIf="doc" class="doc_title">Документ № {{ doc?.id }}</h2>
  <h2 *ngIf="!doc" class="doc_title">Новый документ списания денег</h2>
</div>

<div class="wrapper">
  <form [formGroup]="createForm">
    <div class="topForm drop-padding">
      <mat-form-field appearance="outline">
        <mat-label>Дата</mat-label>
        <input [formControl]="dateFormControl" matInput [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <app-bank-selector [control]="bankFormControl"></app-bank-selector>
      <mat-form-field appearance="outline">
        <mat-label>Описание</mat-label>
        <input [formControl]="descriptionFormControl" matInput placeholder="Описание" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Сумма</mat-label>
        <input [formControl]="valueFormControl" matInput placeholder="Сумма" type="number" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Комиссия</mat-label>
        <input
          [formControl]="commissionFormControl"
          matInput
          placeholder="Комиссия"
          type="number"
        />
      </mat-form-field>
      <button class="submit-button" mat-flat-button color="primary" (click)="save()">
        Сохранить
      </button>
    </div>
  </form>
</div>
